import {ChangeDetectionStrategy, Component, Inject, Input, OnDestroy, OnInit, ViewEncapsulation} from "@angular/core";
import {Marker} from "./marker.schema";
import {GoogleMapsLoader} from "../map-loader.service";

//google maps api declares this var
declare let google:any;
declare let $:any;

@Component({
  changeDetection: ChangeDetectionStrategy.Default,
  encapsulation: ViewEncapsulation.Emulated,
  selector: 'arton-map',
  template: require('./map.component.html'),
})
export class MapComponent implements OnInit {

  isBrowser: boolean;

  @Input() markers: Marker[];

  @Input() center: Marker;

  @Input() buttons: Array<any>;

  map:any;

  id:string = MapComponent._makeId();

  activeButton: any;

  constructor(@Inject('isBrowser') isBrowser: boolean){
    this.isBrowser = isBrowser;
  }

  ngOnInit(): void {

    if(this.isBrowser == false){
      console.info("skipping map...");
      return;
    }

    GoogleMapsLoader.load().then(()=>{
      let map = new google.maps.Map(document.getElementById(this.id), {
        zoom: 13,
        scrollwheel: false,
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        center: { lat: this.center.lat, lng: this.center.lng }
      });

      this.map = map;

      this.markers.forEach(markerCoordinates => {
        let marker = new google.maps.Marker({
          map: map,
          draggable: true,
          animation: google.maps.Animation.DROP,
          position: { lat: markerCoordinates.lat, lng: markerCoordinates.lng, }
        });

        marker.addListener('click', this._toggleBounce(marker));

      });

    });

  }

  /**
   * Changes the center of the map.
   * Coordinates are taken from the button
   * @param button
   */
  setCenter(button: any){
    if (this.map) {
      this.map.panTo(new google.maps.LatLng(button.panTo.lat,button.panTo.lng));
      this.activeButton = button;
    }
  }

  isButtonActive(button: any){
    return this.activeButton === button;
  }

  /**
   * Toggles bounce effect for the marker
   * @param marker
   * @returns {()=>undefined}
   * @private
   */
  private _toggleBounce(marker:any){
    return ()=>{
      if(marker.getAnimation() !== null) {
        marker.setAnimation(null);
      } else {
        marker.setAnimation(google.maps.Animation.BOUNCE);

      }
    }
  }

  /**
   * Generates 5 chars random string
   * @returns {string}
   * @private
   */
  private static _makeId(){
    let text = "";
    let possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

    for( let i=0; i < 5; i++ ){
      text += possible.charAt(Math.floor(Math.random() * possible.length));
    }

    return text;
  }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/+app/shared/map/map.component.ts